import { render, staticRenderFns } from "./FavCandidates.vue?vue&type=template&id=4e1e2460&scoped=true&"
import script from "./FavCandidates.vue?vue&type=script&lang=js&"
export * from "./FavCandidates.vue?vue&type=script&lang=js&"
import style0 from "./FavCandidates.vue?vue&type=style&index=0&id=4e1e2460&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1e2460",
  null
  
)

export default component.exports